(() => {
  const route = globalThis.Shopify?.routes?.root || '/';
  const dialog = document.getElementById('OriginCartDrawer');
  if (!dialog) return;
  const content = dialog.querySelector('[data-cart-drawer-content]');
  const status = dialog.querySelector('[data-cart-drawer-status]');
  const recovery = dialog.querySelector('[data-cart-recovery]');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let refreshPromise;
  let closeTimer;

  function showError(message) {
    status.textContent = message || dialog.dataset.error;
    recovery.hidden = false;
  }

  async function refresh() {
    if (refreshPromise) return refreshPromise;
    refreshPromise = (async () => {
      const response = await fetch(`${route}cart?section_id=origin-cart`, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error(dialog.dataset.error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cart = doc.querySelector('.origin-cart');
      if (!cart) throw new Error(dialog.dataset.error);
      // Reuse the section's actual prices, previews and checkout validation.
      content.replaceChildren(cart);
      const header = document.querySelector('.origin-header__cart');
      if (header) {
        header.querySelector('span').textContent = cart.dataset.cartCount;
        header.setAttribute('aria-label', cart.dataset.cartLabel);
      }
      dialog.querySelector('[data-cart-drawer-count]').textContent = cart.dataset.cartCount;
      globalThis.OriginCartForms.mount(cart);
      content.inert = false;
      status.textContent = '';
      recovery.hidden = true;
    })().finally(() => { refreshPromise = null; });
    return refreshPromise;
  }

  async function open(message) {
    clearTimeout(closeTimer);
    if (!dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('origin-cart-is-open');
    }
    requestAnimationFrame(() => dialog.classList.add('is-visible'));
    status.textContent = dialog.dataset.loading;
    content.replaceChildren();
    try {
      await refresh();
      if (message) showError(message);
    } catch (error) { showError(error.message); }
  }

  function close() {
    dialog.classList.remove('is-visible');
    closeTimer = setTimeout(() => {
      dialog.close();
      document.documentElement.classList.remove('origin-cart-is-open');
      if (document.body.classList.contains('template-cart')) location.reload();
    }, reducedMotion.matches ? 0 : 320);
  }

  async function mutate(endpoint, payload) {
    if (busy) return;
    busy = true;
    content.inert = true;
    content.setAttribute('aria-busy', 'true');
    let failed = false;
    try {
      const response = await fetch(route + endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || dialog.dataset.error);
      await refresh();
    } catch (error) {
      // Never replay an uncertain mutation; recover using the cart page.
      showError(error.message);
      failed = true;
    } finally {
      busy = false;
      content.inert = failed;
      content.removeAttribute('aria-busy');
    }
  }

  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => {
    if (event.target === dialog || event.target.closest('[data-cart-close]')) { close(); return; }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); mutate('cart/change.js', { id: remove.dataset.cartRemove, quantity: 0 }); }
  });
  dialog.addEventListener('change', event => {
    const input = event.target.closest('[data-origin-quantity]');
    if (!input || !input.reportValidity()) return;
    const form = input.closest('form');
    const tagCount = [...form.querySelectorAll('[data-origin-tag="true"]')].reduce((total, field) => total + field.valueAsNumber, 0);
    if (tagCount > 5) return;
    mutate('cart/change.js', { id: input.dataset.lineKey, quantity: input.valueAsNumber });
  });
  dialog.addEventListener('submit', event => {
    if (event.defaultPrevented || event.submitter?.name !== 'update') return;
    event.preventDefault();
    const updates = Object.fromEntries([...event.target.querySelectorAll('[data-origin-quantity]')].map(input => [input.dataset.lineKey, input.valueAsNumber]));
    mutate('cart/update.js', { updates });
  });
  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const offer = event.target.closest('[data-cart-offer-add]');
    if (offer) {
      if (offer.disabled || busy) return;
      const id = offer.closest('[data-cart-offer]').querySelector('[data-cart-offer-variant]').value;
      offer.disabled = true;
      try {
        if (!dialog.open) await open();
        await mutate('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      } finally { offer.disabled = false; }
      return;
    }
    const link = event.target.closest('.origin-header__cart');
    if (!link) return;
    event.preventDefault();
    open();
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-cart-offer-variant]');
    if (!select) return;
    const image = select.closest('[data-cart-offer]').querySelector('[data-loop-image]');
    if (!image || !select.selectedOptions[0]?.dataset.image) return;
    image.removeAttribute('srcset');
    image.src = select.selectedOptions[0].dataset.image;
    image.alt = select.selectedOptions[0].textContent;
  });
  globalThis.OriginCart = { open };
})();
